export default __webpack_public_path__ + "static/freedom-524f834ea0c10f556f98b040dc13fe96.jpg";